import { TRootState } from '@/redux/rootReducer';

export const getSelectedFilter = (state: TRootState) => state.search.selectedFilter || null;
export const isHisotgramLoading = (state: TRootState) => state.search.isHistogramLoading;
